/**
 * 租租车的所有APP
 */


/**
 * app分享接口
 *
 * @export
 * @param {object} shareConfig
 * ```js
 * {
 *   title: '',  // 微博没用上title数据
 *   content: '',
 *   photo: '',
 *   shareUrl: '',
 *   sharePlatform: [],
 *   success: () => {}
 * }
 * ```
 * @returns
 */
export default function share(shareConfig) {
  if (typeof window.zzc !== 'object') return;

  zzc.call('Share', shareConfig);
}



// WEBPACK FOOTER //
// ./src/components/Share/app.js